import { TItemDescriptions } from 'factions/factionTypes'
import { tagAs } from 'factions/metatagger'
import { COMBAT_PHASE, DURING_GAME, END_OF_TURN, HERO_PHASE, MOVEMENT_PHASE, SAVES_PHASE, SHOOTING_PHASE } from 'types/phases'

const Spells = {
  'Lore of the Deepwood': {
    effects: [
      {
        name: `Jade Thorns: Casting value of 6 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Sylvaneth Wizard to cast this spell, pick a visible friendly Sylvaneth unit wholly within 12" of them to be the target, then make a casting roll of 2D6. 
        Effect: Add 1 to wound rolls for the target's combat attacks for the rest of the turn, including attacks made with Companion weapons.`,
        when: [HERO_PHASE],
      },
      {
        name: `Zephyrspite Rush: Casting value of 6`,
        desc: `Declare: Pick a friendly Sylvaneth Wizard to cast this spell, pick a visible friendly Sylvaneth unit wholly within 12" of them to be the target, then make a casting roll of 2D6. 
        Effect: For the rest of the turn, the target can use Charge abilities even if it used a Run ability in the same turn.`,
        when: [HERO_PHASE],
      },
      {
        name: `Grasping Roots: Casting value of 5`,
        desc: `Declare: Pick a friendly Sylvaneth Wizard to cast this spell, pick a visible enemy unit within 18" of them to be the target, then make a casting roll of 2D6. 
        Effect: Until the start of your next turn:
        The target cannot use Run abilities.
        Subtract 1 from charge rolls for the target.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Lords of the Clan (AoR)': {
    effects: [
      {
        name: `Call Forth the Forest: Casting value of 6 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Lords of the Clan Wizard to cast this spell, then make a casting roll of 2D6.
        Effect: If there are fewer than 9 friendly Awakened Wyldwoods on the battlefield, you can set up an Awakened Wyldwood wholly within 24" of the caster, more than 3" from all objectives and more than 1" from all enemy units and other terrain features. If there are 9 friendly Awakened Wyldwoods on the battlefield, Heal (3) each friendly Awakened Wyldwood instead.`,
        when: [HERO_PHASE],
      },
      {
        name: `Jade Winds: Casting value of 6`,
        desc: `Declare: Pick a friendly Lords of the Clan Wizard to cast this spell, pick 1 of the friendly Manifestations below that is not on the battlefield, then make a casting roll of 2D6.
        Gladewyrm
        Spiteswarm Hive
        Vengeful Skullroot
        Effect: If you picked a Gladewyrm or Vengeful Skullroot, set it up wholly within 12" of the caster, visible to them and more than 9" from all enemy units. If you picked a Spiteswarm Hive, set it up wholly within 12" of the caster and visible to them.`,
        when: [HERO_PHASE],
      },
      {
        name: `Spiteswarm Hive - Anger the Hive`,
        desc: `Effect: If this Manifestation was not set up this turn, add 10 to the Attacks characteristic of this Manifestation's ranged weapons for the rest of the phase, but all of the shooting attacks it makes this phase must target an enemy unit within 9" of it.`,
        when: [SHOOTING_PHASE],
      },
      {
        name: `Gladewyrm - Eldritch Hunters`,
        desc: `Effect: If this Manifestation is not in combat, remove it from the battlefield and set it up again on the battlefield more than 9" from all enemy non-Wizard non-Priest units and more than 3" from all enemy Wizards and enemy Priests.`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `Gladewyrm - Feed on Eldritch Energy - Passive`,
        desc: `Effect: Subtract 1 from casting rolls, unbinding rolls, chanting rolls and banishment rolls for enemy units while they are in combat with this Manifestation.`,
        when: [HERO_PHASE],
      },
      {
        name: `Vengeful Skullroot - Vengeful Terrors - Passive`,
        desc: `Effect: Subtract 1 from hit rolls for attacks made by enemy units while they are within 6" of this Manifestation.`,
        when: [DURING_GAME],
      },
    ],
  },
  'Soulpod Guardians (AoR)': {
    effects: [
      {
        name: `Cradling Vines: Casting value of 7 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Soulpod Guardians Wizard to cast this spell, pick an objective within 18" of them that has not been picked to be the target of this spell this turn to be the target, then make a casting roll of 2D6.
        Effect: Until the start of your next turn, add 5 to control scores of friendly units while they are contesting the target objective.`,
        when: [HERO_PHASE],
      },
      {
        name: `Jade Winds: Casting value of 6`,
        desc: `Declare: Pick a friendly Soulpod Guardians Wizard to cast this spell, pick 1 of the friendly Manifestations below that is not on the battlefield, then make a casting roll of 2D6.
        Gladewyrm
        Spiteswarm Hive
        Vengeful Skullroot
        Effect: If you picked a Gladewyrm or Vengeful Skullroot, set it up wholly within 12" of the caster, visible to them and more than 9" from all enemy units. If you picked a Spiteswarm Hive, set it up wholly within 12" of the caster and visible to them.`,
        when: [HERO_PHASE],
      },
      {
        name: `Spiteswarm Hive - Anger the Hive`,
        desc: `Effect: If this Manifestation was not set up this turn, add 10 to the Attacks characteristic of this Manifestation's ranged weapons for the rest of the phase, but all of the shooting attacks it makes this phase must target an enemy unit within 9" of it.`,
        when: [SHOOTING_PHASE],
      },
      {
        name: `Gladewyrm - Eldritch Hunters`,
        desc: `Effect: If this Manifestation is not in combat, remove it from the battlefield and set it up again on the battlefield more than 9" from all enemy non-Wizard non-Priest units and more than 3" from all enemy Wizards and enemy Priests.`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `Gladewyrm - Feed on Eldritch Energy - Passive`,
        desc: `Effect: Subtract 1 from casting rolls, unbinding rolls, chanting rolls and banishment rolls for enemy units while they are in combat with this Manifestation.`,
        when: [HERO_PHASE],
      },
      {
        name: `Vengeful Skullroot - Vengeful Terrors - Passive`,
        desc: `Effect: Subtract 1 from hit rolls for attacks made by enemy units while they are within 6" of this Manifestation.`,
        when: [DURING_GAME],
      },
    ],
  },
} satisfies TItemDescriptions

export default tagAs(Spells, 'spell')
